import type { OnDestroy } from '@angular/core';
import { ChangeDetectorRef, Component, inject } from '@angular/core';

import { Subject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import type { ReferralsPortalApplication } from '@core/referrals-types';
import { ReferralsPortalApplicationStatus } from '@core/referrals-types';
import { TimeAgoPipe } from '@core/time-legacy';
import type { DialogComponentI, IconName } from '@core/user-interface-legacy';
import {
  AvatarComponent,
  BoxComponent,
  DialogBodyComponent,
  DialogHeaderComponent,
  DialogRef,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

type ReferralsDialogData = {
  referral: ReferralsPortalApplication;
  translations: Record<string, { status: string; icon: IconName }>;
  showStatus: boolean;
};

@Component({
  selector: 'rtr-referrals-dialog',
  templateUrl: './referrals-dialog.component.html',
  styleUrls: ['./referrals-dialog.component.less'],
  imports: [
    DialogHeaderComponent,
    AvatarComponent,
    HeadingComponent,
    IconComponent,
    DialogBodyComponent,
    BoxComponent,
    TimeAgoPipe,
    TranslatePipe,
  ],
})
export class ReferralsDialogComponent
  implements DialogComponentI<ReferralsDialogData, boolean>, OnDestroy
{
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly dialogRef = inject<DialogRef<ReferralsDialogComponent>>(
    DialogRef<ReferralsDialogComponent>,
  );
  public readonly ReferralStatus: typeof ReferralsPortalApplicationStatus =
    ReferralsPortalApplicationStatus;

  public referral: ReferralsPortalApplication;
  public statusTranslationsMap: Record<string, { status: string; icon: IconName }>;
  public showStatus: boolean;

  public ngOnDestroy$ = new Subject<void>();

  public setDialogData(data: ReferralsDialogData): void {
    this.referral = data.referral;
    this.statusTranslationsMap = data.translations;
    this.showStatus = data.showStatus;
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public close(): void {
    this.dialogRef.close();
  }
}
